export default __webpack_public_path__ + "static/media/temp_green_light.627b592b.svg";